import _ from 'lodash'

import productService from '@/services/serli/product'
import qualificationService from '@/services/salesbox/qualify'
import {convertFiltersArray, convertFiltersValuesBackToMetric} from "@/common/helpers";

const environmentsStaticState = {
    environments: [],
    market: "INDU",
}

const buildingAndShelvingState = {
    currentStepSurvey: null,
    fields: [],
    filters: [],
    minimumAisleWidth: '',
    maxLiftingHeight: '',
    rampLength: '',
    rampHeight: '',
    passageWidth: '',
    passageHeight: '',
    passageFirstStringer: '',
    ceilingHeight: '',
    luminaireHeight: '',
    residualCapacityMaxHeight: '',
}

const workEnvironmentState = {
    environment: null,
    insideFloorType: null,
    outsideFloorType: null,
    floorSurfaceType: null,
    usageHoursPerDay: '',
    workstationNumber: null,
    speedLimitExist: null,
    speedLimit: null,
    workConditions: [],
    loadTimeAvailable: '',
    loadType: null,
    loadRoom: null,
    maintenanceContract: null,
    provider: null,
}

const resultsMachinesState = {
    machineResults: [],
    selectedMachineResults: [],
    currentStepMachineResults: 1
}

const initialState = {
    currentContext: null,
    currentStep: null,
    steps: [],
    nextStepAllowed: false,
    ...buildingAndShelvingState,
    ...workEnvironmentState,
    ...resultsMachinesState,
    ...environmentsStaticState,
};

export const state = { ...initialState };

export default {
    namespaced: true,
    state,
    mutations: {
        reset (state) {
            const s = _.cloneDeep(initialState);
            Object.keys(s).forEach(key => {
                if (key !== 'environment' && key !== 'environments' && key!=='currentContext') state[key] = s[key];
            })
        },
        setCurrentContext(state, context) {
            state.currentContext = context;
        },
        setCurrentStep(state, step) {
            state.currentStep = step;
        },
        setSteps(state, steps) {
            state.steps = steps;
        },
        setNextStepAllowed(state, value) {
            state.nextStepAllowed = value;
        },
        // -------------------
        // - Building and Shelving
        // -------------------
        resetBuildingAndShelving(state) {
            const s = _.cloneDeep(buildingAndShelvingState);
            Object.keys(s).forEach(key => state[key] = s[key])
        },
        setDefaultStepFields(state, value) {
            Object.keys(value).forEach(index => {
                // console.log(index);
                if (value[index] && !state.fields[index]) state.fields[index] = value[index];
            })
        },
        setFields(state, payload) {
            state.fields[payload.survey][payload.field] = payload.value;
        },
        setFilters(state, payload) {
            state.filters[payload.survey] = payload.value;
        },
        setMinimumAisleWidth(state, value) {
            state.minimumAisleWidth = value;
        },
        setMaxLiftingHeight(state, value) {
            state.maxLiftingHeight = value;
        },
        setRampLength(state, value) {
            state.rampLength = value;
        },
        setRampHeight(state, value) {
            state.rampHeight = value;
        },
        setPassageWidth(state, value) {
            state.passageWidth = value;
        },
        setPassageHeight(state, value) {
            state.passageHeight = value;
        },
        setPassageFirstStringer(state, value) {
            state.passageFirstStringer = value;
        },
        setCeilingHeight(state, value) {
            state.ceilingHeight = value;
        },
        setLuminaireHeight(state, value) {
            state.luminaireHeight = value;
        },
        setResidualCapacityMaxHeight(state, value) {
            state.residualCapacityMaxHeight = value;
        },
        // -------------------
        // - Work Environment
        // -------------------
        resetWorkEnvironment(state) {
            const s = _.cloneDeep(workEnvironmentState);
            Object.keys(s).forEach(key => state[key] = s[key])
        },
        setEnvironments(state, value) {
            state.environments = value;
        },
        setEnvironment(state, value) {
            state.environment = value;
        },
        setInsideFloorType(state, value) {
            state.insideFloorType = value;
        },
        setOutsideFloorType(state, value) {
            state.outsideFloorType = value;
        },
        setFloorSurfaceType(state, value) {
            state.floorSurfaceType = value;
        },
        setUsageHoursPerDay(state, value) {
            state.usageHoursPerDay = value;
        },
        setWorkstationNumber(state, value) {
            state.workstationNumber = value;
        },
        setSpeedLimitExist(state, value) {
            state.speedLimitExist = value;
        },
        setSpeedLimit(state, value) {
            state.speedLimit = value;
        },
        setWorkConditions(state, value) {
            state.workConditions = value;
        },
        setLoadTimeAvailable(state, value) {
            state.loadTimeAvailable = value;
        },
        setLoadType(state, value) {
            state.loadType = value;
        },
        setLoadRoom(state, value) {
            state.loadRoom = value;
        },
        setMaintenanceContract(state, value) {
            state.maintenanceContract = value;
        },
        setProvider(state, value) {
            state.provider = value;
        },
        // -------------------
        // -------------------
        resetMachineResults(state) {
            const s = _.cloneDeep(resultsMachinesState);
            Object.keys(s).forEach(key => state[key] = s[key])
        },
        setMachineResults(state, value) {
            state.machineResults = value;
        },
        setSelectedMachineResults(state, value) {
            state.selectedMachineResults = value;
        },
        increaseCurrentStepMachineResults(state) {
            state.currentStepMachineResults++;
        },
    },
    actions: {
        async fetchMachineResults({state, rootState, commit}){
            // -------------------
            // - MARKET
            // -------------------
            let filters = [
                //{
                //    type: "select",
                //    attribute: "markets",
                //    value: "INDU",
                //},
            ];

            //@todo Envoyer impérativement les valeurs en mètres

            // -------------------
            // - MINIMUM AISLE WIDTH
            // -------------------
            // @todo a voir avec martijn sur l'utilisé de prendre en compte (en com sur Gdrive)
            if(state.minimumAisleWidth.length > 0){
                const minimumAisleWidthFilters= ["-ast_aisle_width_for_1000_1200_pallet_widthwise","overall_length_without_tools","-ast_Aisle_width_for_800_x_1200_pallet_lengthwise","turning_radius"]
                minimumAisleWidthFilters.forEach((filter)=>{
                    filters.push({
                        type: "slider",
                        attribute: filter,
                        group : minimumAisleWidthFilters[0]+'_group',
                        minValue: 0,
                        maxValue: (parseInt(state.minimumAisleWidth))/1000,
                        unit_code: "METER",
                    })
                })
            }

            // -------------------
            // - MAX LIFTING HEIGHT
            // -------------------
            if(state.maxLiftingHeight.length > 0){
                const maxLiftingHeightFilters=["max_lifting_height","height_boom_extended","extended_mast_height"]
                maxLiftingHeightFilters.forEach((filter)=>{
                    filters.push({
                        type: "slider",
                        attribute: filter,
                        group : maxLiftingHeightFilters[0]+'_group',
                        minValue: (parseInt(state.maxLiftingHeight)+200)/1000,
                        maxValue: 9999,
                        unit_code: "METER",
                    })
                })
            }


            // -------------------
            // - MINIMUM RAMP LADEN UNLADEN
            // -------------------

            if(state.rampLength.length > 0 && state.rampHeight.length > 0){
                const rampPercentageFilters=[
                    "surmontable_slope_percent_laden",
                    "max_gradeability_laden"
                ]

                let rampPercentage = (Math.round(((parseInt(state.rampHeight)/parseInt(state.rampLength))*100) * 100) / 100);
                rampPercentageFilters.forEach((filter)=> {
                    filters.push({
                        type: "slider",
                        attribute: filter,
                        group : rampPercentageFilters[0]+'_group',
                        minValue: rampPercentage,
                        maxValue: 9999,
                        //unit_code: "METER",
                    })
                })
            }

            // -------------------
            // - OVERALL WIDTH
            // -------------------
            if(state.passageWidth.length > 0){
                filters.push({
                    type: "slider",
                    attribute: "l10_overall_width",
                    minValue: 0,
                    maxValue: parseInt(state.passageWidth)/1000,
                    unit_code: "METER",
                })
            }

            // -------------------
            // - HEIGHT MAST LOWERED
            // -------------------

            if(state.passageHeight.length > 0){
                const passageHeightFilters= [
                    "height_boom_lowered",
                    "lowered_mast_height",
                    "height_tiller_up_max",
                    "height_tiller_up_std",
                    "standard_mast_height_low"
                ]
                passageHeightFilters.forEach((filter)=> {
                    filters.push({
                        type: "slider",
                        attribute: filter,
                        group: 'passage_height_group',
                        minValue: 0,
                        maxValue: parseInt(state.passageHeight)/1000,
                        unit_code: "METER",
                    })
                })
            }

            // -------------------
            // - EXTENDED MAST LOWERED (ceilingHeight)
            // -------------------

            if(state.ceilingHeight.length > 0){
                const ceilingHeightFilters= [
                    "height_boom_extended",
                    "extended_mast_height",
                    "height_tiller_up_max",
                    "height_tiller_up_std",
                    "standard_mast_height_up"
                ]
                ceilingHeightFilters.forEach((filter)=> {
                    filters.push({
                        type: "slider",
                        attribute: filter,
                        group: 'ceiling_height_group',
                        minValue: 0,
                        maxValue: parseInt(state.ceilingHeight)/1000,
                        unit_code: "METER",
                    })
                })
            }

            // -------------------
            // - EXTENDED MAST LOWERED (luminaireHeight)
            // -------------------

            if(state.luminaireHeight.length > 0){
                const luminaireHeightFilters= [
                    "height_boom_lowered",
                    "lowered_mast_height",
                    "height_tiller_up_max",
                    "height_tiller_up_std",
                    "standard_mast_height_low"
                ]
                luminaireHeightFilters.forEach((filter)=> {
                    filters.push({
                        type: "slider",
                        attribute: filter,
                        group: 'luminaire_height_group',
                        maxValue: parseInt(state.luminaireHeight)/1000,
                        minValue: 0,
                        unit_code: "METER",
                    })
                })
            }

            // -------------------
            // - RESIDUAL CAPACITY AT MAX HEIGHT
            // -------------------
            if(state.residualCapacityMaxHeight.length > 0){
                const residualCapacityMaxHeightFilters= [
                    "max_capacity",
                    "residual_capacity_with_integrated_side_shift_industrial_load_chart",
                    "residual_capacity_at_max_height"
                ]
                residualCapacityMaxHeightFilters.forEach((filter)=> {
                    filters.push({
                        type: "slider",
                        attribute: filter,
                        group: 'residualCapacityMaxHeight_group',
                        minValue: parseInt(state.residualCapacityMaxHeight),
                        maxValue: 9999999,
                        unit_code: "KILOGRAM",
                    })
                })
            }


            // -------------------
            // - ENVIRONMENT
            // -------------------
            if(state.environment) {
                let energyFilterValue = null;

                if (state.environment === 'inside')
                    energyFilterValue = [
                        'machineEnergy_Electric',
                        'machineEnergy_Battery',
                        'machineEnergy_Bienergy',
                        'machineEnergy_Lpg',
                        'machineEnergy_Manual'
                    ]
                else if (state.environment === 'outside')
                    energyFilterValue = [
                        'machineEnergy_Diesel',
                        'machineEnergy_Bienergy',
                        'machineEnergy_Lpg',
                        'machineEnergy_Manual'
                    ]
                else if (state.environment === 'outside_and_inside')
                    energyFilterValue = [
                        'machineEnergy_Bienergy',
                        'machineEnergy_Lpg',
                        'machineEnergy_Manual'
                    ]
                filters.push({
                    type: "select",
                    attribute: "energy",
                    group: 'energy',
                    value: energyFilterValue,
                })
            }

            // -------------------
            // - SPEED
            // -------------------
            //if(state.speedLimit){
            //    filters.push({
            //        type: "slider",
            //        attribute: "speed_of_travel_unladen",
            //        minValue: 0,
            //        maxValue: parseInt(state.speedLimit),
            //        unit_code: "KILOMETER_PER_HOUR",
            //    })
            //}
//

            filters = JSON.parse(JSON.stringify(filters));
            //filters = await convertFiltersValuesBackToMetric(filters);
            filters = await convertFiltersArray(filters);

            let surveyFilters = new FormData();

            state.fields.forEach((survey, index) => {
                if (survey) {
                    Object.keys(survey).forEach(filter => {
                        surveyFilters.append(`filters[${index}][${filter}]`, survey[filter]);
                    })
                }
            })

            filters = surveyFilters;

            /* old filters
            return qualificationService.getProducts({
                filters: filters
            }*/
            return qualificationService.getProducts(filters, {
                productType: 'machines',
                brand: rootState.settings.brand,
                category: 'qualification',
                market : state.market,
                size: 999,
                page : 1,
                locale: rootState.settings.locale.replace('_', '-'),
                unit: rootState.settings.unitType,
                context:state.currentContext
            })
            .then((response) => {
                if(response.data.code === 200) {
                    commit('setMachineResults', response.data.data.results);
                }
            })
        },
        fetchEnvironments({state, rootState, commit}) {
            // let response = require('@/common/utils/env.json');
            // console.log(response.datas);
            // commit('setEnvironments', response.context);
            qualificationService.get(state.market, rootState.settings.locale)
                .then((response) => {

                    if(response.data.code === 200 && response.data.contexts) {
                        commit('setEnvironments', response.data.contexts);
                    }
                })
        }
    }
};
